
import React, { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { FaPlusCircle } from "react-icons/fa"; 
import api from '../utils/intercepter/axiosConfig.js'

import { ToastContainer , toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const CréerVentes = () => {

  const {state} = useLocation();

  const TOAST_POSITION = "top-right";
  

  const [nni_acheteur, setNniAcheteur] = useState('')
  const [nom_acheteur, setNomAcheteur] = useState('')
  const [montant, setMontant] = useState('')
  const [id_notaire, setIdNotaire] = useState('')
  const [num_tf, setNumTF] = useState('')

  const [numActeVente, setNumActeVente] = useState("");
  const [dateActeVente, setDateActeVente] = useState("");
  const [civilie, setCivilie] = useState("");

  const [errors, setErrors] = useState({});



  useEffect(() => {
    if (state?.idNotaire && state?.numTf) {
      setIdNotaire(state.idNotaire);
      setNumTF(state.numTf);
    }
  }, [state]);

  // Validations 

  const isValidNNI = (value) => {
    if (!/^\d{10}$/.test(value)) return false;
    return parseInt(value) % 97 === 1;
  }

  const validForms = () => {
    const newErrors = {};

    if(!isValidNNI(nni_acheteur)){
      newErrors.nni_acheteur = "Le NNI n’est pas valide.";
    }

    if(!nom_acheteur || nom_acheteur.trim() === ""){
      newErrors.nom_acheteur = "Le nom de l'acheteur est obligatoire";
    }

    if(montant <= 0 || isNaN(montant)){
      newErrors.montant = "Le montant doit etre un nombre positive";
    }

    if(numActeVente <= 0 || isNaN(numActeVente)){
      newErrors.numActeVente = "Le numéro du acte de vente doit etre positive";
    }

    if (!/^\d{4}-\d{2}-\d{2}$/.test(dateActeVente)) {
      newErrors.dateActeVente = "La date doit être au format AAAA-MM-JJ.";
    }

    if(civilie !== "0" && civilie !== "1"){
      newErrors.civilie = "Veuillez sélectionner une civilité valide.";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;

  }


const handleSubmit =  async (e) => {

  e.preventDefault();

  if(!validForms()){
    return;
  }


  // console.log("id_notaire : ", id_notaire, "num_tf : ", num_tf, "nni_acheteur : ",
  //    nni_acheteur, "nom_acheteur : ", nom_acheteur, " montant : ", montant,
  //   "numActeVente : ", numActeVente, "dateActeVente : ", dateActeVente , "civilie : ", civilie);

  // call Api pour initiliser la vente
  try {
    const response = await api.post("/auth/initier_vente",{
      id_notaire: id_notaire,
    num_tf: num_tf,
    nni_acheteur: nni_acheteur,
    nom_acheteur: nom_acheteur,
    montant: montant,
    num_acte_vente: numActeVente,
    date_acte_vente: dateActeVente,
    civilie: civilie
    });

    if(response.data.success){
      toast.success(response.data.message,{
        position: TOAST_POSITION,
      });
      setNniAcheteur('');
      setNomAcheteur('');
      setMontant('');
      setNumActeVente('');
      setDateActeVente('');
      setCivilie('');
      setErrors({});
    }
    else{
      toast.error(response.data.message,{
        position: TOAST_POSITION,
      })
    }
  } catch (error) {
    toast.error("Erreur de connexion au serveur", {
      position: TOAST_POSITION,
    });
}

}
  return (

    <div className="container py-5">
          <div className="row justify-content-center">
          <div className="col-12 col-md-10 col-lg-8 col-xl-6">
              <div className="card  border-1 rounded-4">
                <div className="card-body">
                  {/* Header */}
                  <div className="d-flex align-items-center justify-content-center mb-4">
                    <h3 className="text-black fw-bold mb-0">
                      <FaPlusCircle  className="me-2" />
                      Créer une Vente
                    </h3>
                  </div>

                  <hr />
  
                  <form onSubmit={handleSubmit}>
  
                <div className="row">
                  <div className="col-md-6 form-group mb-3">
                    <label htmlFor="nni_acheteur">NNI de l'Acheteur</label>
                    <input
                      type="text"
                      className="form-control"
                      id="nni_acheteur"
                      placeholder="Entrez le NNI de l'acheteur"
                      name="nni_acheteur"
                      onChange={(e) => setNniAcheteur(e.target.value)}
                      required
                    />

                    {errors.nni_acheteur && (
                      <span className="text-danger">{errors.nni_acheteur}</span>
                    )}

                  </div>

                  <div className="col-md-6 form-group mb-3">
                    <label htmlFor="nom_acheteur">Nom de l'Acheteur</label>
                    <input
                      type="text"
                      className="form-control"
                      id="nom_acheteur"
                      name="nom_acheteur"
                      placeholder="Entrez le nom de l'acheteur"
                      onChange={(e) => setNomAcheteur(e.target.value)}
                      required
                    />

                    {errors.nom_acheteur && (
                      <span className="text-danger">{errors.nom_acheteur}</span>
                    )}

                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 form-group mb-3">
                    <label htmlFor="montant">Montant de Vente</label>
                    <input
                      type="number"
                      className="form-control"
                      id="montant"
                      name="montant"
                      placeholder="Entrez le montant de la vente"
                      onChange={(e) => setMontant(e.target.value)}
                      required
                    />

                    {errors.montant && (
                      <span className="text-danger">{errors.montant}</span>
                    )}

                  </div>

                  <div className="col-md-6 form-group mb-3">
                    <label htmlFor="num_acte_vente">Numéro de l'Acte de Vente</label>
                    <input
                      type="number"
                      className="form-control"
                      id="num_acte_vente"
                      name="num_acte_vente"
                      placeholder="Entrez le numéro de l'acte de vente"
                      onChange={(e) => setNumActeVente(e.target.value)}
                      required
                    />


                    {errors.numActeVente && (
                      <span className="text-danger">{errors.numActeVente}</span>
                    )}

                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 form-group mb-3">
                    <label htmlFor="date_acte_vente">Date de l'Acte de Vente</label>
                    <input
                      type="date"
                      className="form-control"
                      id="date_acte_vente"
                      name="date_acte_vente"
                      onChange={(e) => setDateActeVente(e.target.value)}
                      required
                    />


                    {errors.dateActeVente && (
                      <span className="text-danger">{errors.dateActeVente}</span>
                    )}

                  </div>

                  <div className="col-md-6 form-group mb-3">
                    <label htmlFor="civilie">Civilité</label>
                    <select
                      className="form-control"
                      id="civilie"
                      name="civilie"
                      onChange={(e) => setCivilie(e.target.value)}
                      required
                    >
                      <option value="">-- Sélectionner --</option>
                      <option value="0">M.</option>
                      <option value="1">Mme</option>
                    </select>

                    {errors.civilie && (
                      <span className="text-danger">{errors.civilie}</span>
                    )}

                  </div>
                </div>

                <div className="d-grid">
                  <button type="submit" className="btn btnStyle">
                    Créer Une Vente
                  </button>
                </div>
              </form>

  
                 
                </div>
              </div>
            </div>
          </div>

          <ToastContainer />
        </div>

   
  );
};


export default CréerVentes;


